import React from 'react';
import {Grid, Card, CardContent, Divider, Tooltip,
        Button, Modal, InputBase, FormControl, withStyles, Link,
        ClickAwayListener, Dialog } from '@material-ui/core';
import {ViewCarouselRounded, PeopleAlt, TableChartOutlined, LocalOfferOutlined, Apps,VisibilityOutlined, VisibilityOffOutlined,
        ExpandMore, ExpandLess, Lock, BubbleChart, Mic,
        PetsOutlined, SportsEsportsOutlined} from '@material-ui/icons'
import {withApollo} from 'react-apollo'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import gql from 'graphql-tag';
import request from 'superagent';

import config from '../../../config/backend'
import GameTopPanel from './gameTopPanel'
import FooterPanel from './gameFooterPanel.tsx';
import {HOME_PAGE_JAMBUILDER_QUERY, HOME_PAGE_GAME_QUERY, GET_USER_ACTIVITY, GET_JAMS_TEMPLATES, GET_JAMBUILDER_BY_ID} from '../../../api/graphql'
import CardLoader from '../user_interface/assets/cardLoader'
import {CREATE_GAME, CREATE_JAMBUILDER, USER_UPDATE_ACTIVITY,GAME_GD_UPDATE_BY_ID, DUPLICATE_GAME} from '../../../api/graphql-mutation'
import { getUserId, getUsername, replaceWhiteSpace} from '../../../utility/function';
import {styles} from './assets/frontPageUI'

/** Components */
import { HelpFab } from '../../fabs/helpFab/helpFab';
import { HelpPopover } from '../../popovers/helpPopover/helpPopover';

/**temporary mock data */
import {gd,gd2} from '../../../utility/temp'
import { appConfig } from '../../../app/app.config'

class FrontPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            jamListLength: 12,
            jamBuilderListLength: 3,
            templateListLength: 12,

            open: false,
            type: '',
            password: '',
            name: '',
            jamBuilder: [],
            deck: '1',
            loaded: true,

            //Activity list
            activityList: [],

            //Personal Jambuilders
            jambuilders: [],
            //Public jambuilders
            publicJambuilders: [],

            eventList: [],

            gamejams: [],
            spectateGame: [],
            uid: null,

            anchorEl: null,
            stickyBits: null,

            //Dialog configs
            dialogOpen: false,
            selectedJB: {
                type: "story",
                jbData: null,
            },
            dialogDeck: null,

            templateDialog: false,

            templateImage: null,

            openPreview: this.props?.location?.state?.openPreview,

            loading: false,
        }

        this.jbIndex = null
    }

    //Featured templates hosted from the Quickstart boxes; fetched lazily by id on click.
    //Featured template ids are deployment-specific (main vs temp site); see app.config.
    featuredIds = {
        brainstorm: appConfig.brainstormTemplateId,
        cover: appConfig.coverTemplateId,
        turntaking: appConfig.turntakingTemplateId,
        freeplay: appConfig.freeplayTemplateId,
    }

    //Lazily fetch a featured template by id and open the preview dialog (host/customize).
    //flags carry the featured kind (brainstorm/cover) that createGame reads via selectedJB.
    openFeaturedTemplate = async (id, flags = {}) => {
        try{
            const res = await this.props.client.query({
                query: GET_JAMBUILDER_BY_ID(id),
                fetchPolicy: "no-cache"
            })
            const jbData = res.data.jamBuilderById
            if(!jbData){
                console.log("Unable to find featured template", id)
                return
            }
            this.setState({
                dialogDeck: null,
                dialogOpen: true,
                selectedJB: { jbData, type: "custom-other", ...flags }
            })
        }catch(err){
            console.error("featured template fetch failed:", err)
        }
    };

    componentDidMount() {
        document.body.style.background = "#F2F2F2"

        this.props.client.query({
            query: gql`${HOME_PAGE_GAME_QUERY}`
        })
        .then((res) =>{
            const {gameMany} = res.data
            // console.log(gameMany)

            let readyGame = gameMany.filter((n)=>{return n.status === "ready"})
            let spectateGame = gameMany.filter((n)=>{return n.status === "started" && n.data.general.spectateMode})

            const gamejams = readyGame.filter((game)=>{return game.automation !== "2" && game.automation !== "3"})
            this.setState({
                loaded: true,
                gamejams: gamejams.reverse(),
                spectateGame: spectateGame.reverse(),

            })
        })
        .catch(() =>{
            return <div>Error :( : frontpage </div>
        })

        if(this.props?.location?.state?.type){
            const {type, selectedJB} = this.props.location.state
            this.setState({
                type: type,
                selectedJB: {
                    type: selectedJB.type,
                    jbData: selectedJB?.jbData
                }
            }, () =>{

                this.handleOpen(type)
                this.jbIndex = this.props.location.state.jbIndex
                this.jbID = this.state.selectedJB.jbData._id
            })
        }

    }

    render(){
        const {classes} = this.props
        const {gamejams, jambuilders, publicJambuilders, uid, activityList, spectateGame, eventList} = this.state
        const popoverId = this.state.anchorEl ? 'help-popover' : undefined;

        //Shorthand alternative to "if" statement
        //So why is this a if statement? Putting the getUserId() in componentDidMount would return null even though
        //the user is logged in but will then return a valid uid after each subsequent function calls.
        //Therefore the stupid solution is to put it into render() and run the function until it returns
        //a valid uid and then query the data. This is what I call a pro gamer move
        Boolean(!uid && getUserId()) && this.jamPageQuery(getUserId())

        // console.log(this.state.eventList)

        return(
            <>
                {!this.state.loaded ?
                    <div style ={{position: "absolute", left: "50%", top: "40%"}}><CardLoader/></div>
                    :
                    <>
                        {/* TOP PANEL */}
                        <GameTopPanel/>

                        {/* MAIN */}
                        <Grid container spacing={4} className={classes.container}>
                            {/* LEFT COLUMN */}
                            <Grid item sm={9} xs={12}>
                                {/* BANNER */}
                                <img alt="banner" className={classes.banner} src={require('../../../element/2024feb/banner_front.png')}/>
                                {/* FEATURED GAME JAM ROW */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            Featured Game Jam: Story Game
                                        </Grid>
                                    </Grid>

                                </Card>

                                <Card className={classes.card}>
                                    <CardContent className={classes.cardContent}>
                                        <Grid container direction="row">
                                            <Grid item xs={2}>
                                                <div style={{position:"relative", width:"140px"}}>
                                                    <div className={classes.featuredType}>GAME</div>
                                                    <img alt="banner" style={{borderRadius:"10px", width:"140px"}} src={require('../../../element/OUAT.png')}/>
                                                    <p className={classes.featuredTitle}>Story Game</p>
                                                </div>
                                            </Grid>
                                            <Grid item xs={8}>

                                                <div style={{position:"absolute", right:"20px", top:"10px", fontSize:"14px"}}>
                                                    <span style={{fontSize:"12px"}}><PeopleAlt style={{color:"#4f4f4f"}}/></span> 2 - 6
                                                </div>
                                                <p style={{fontSize:"14px", marginLeft:"10px"}}>
                                                    Story Game is a storytelling card game. <br/><br/>
                                                    Tell a fairy tale as a group, one Storyteller at a time while the other
                                                    players have a chance to "interrupt" the story and become the Storyteller
                                                    <br/><br/>
                                                    <Button style={{color:"#4F4F4F",textTransform: "none"}} className={classes.displayBtn} disabled
                                                    startIcon={<Mic style={{color:"#4173D6"}}/>}>
                                                        <span style={{fontSize:"14px", fontFamily:"Arial"}}>You can host this game</span>
                                                    </Button><br/>
                                                    <Button style={{color:"#4F4F4F",textTransform: "none", fontSize:"14px", fontFamily:"Arial"}} className={classes.displayBtn} disabled
                                                    startIcon={<BubbleChart style={{color:"#4173D6"}}/>}>
                                                        <span style={{fontSize:"14px", fontFamily:"Arial"}}>You can modify this game</span>
                                                    </Button>
                                                    <Button
                                                        onClick={()=>{
                                                            this.setState({
                                                                dialogOpen: true,
                                                                selectedJB:{
                                                                    type: "story"
                                                                }
                                                            });
                                                        }}
                                                        className={classes.modBtn}
                                                    >
                                                        VIEW MORE
                                                    </Button>
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>


                                {/* HOST OR BUILD FROM JAMIT TEMPLATES */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            Quickstart Jams
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/* QUICK START WITH JAM TEMPLATES */}
                                <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"10px"}}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                justify="center"
                                                alignItems="center"
                                                spacing={0}
                                                className={classes.displayBox}
                                                onClick={()=>{
                                                    this.openFeaturedTemplate(this.featuredIds.freeplay, {freeplay: true})
                                                }}
                                            >
                                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"2.5em"}} src={require('../../../element/2024feb/ballspin.png')}/>
                                                <div className={classes.displayBg}>
                                                    <div className={classes.displayTitleWrapper}>
                                                        <p className={classes.displayTitle}>FREESTYLE JAM</p>
                                                        <p className={classes.displaySubTitle}>Anything goes!</p>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                justify="center"
                                                alignItems="center"
                                                spacing={0}
                                                className={classes.displayBox}
                                                onClick={()=>{
                                                    this.openFeaturedTemplate(this.featuredIds.turntaking, {turntaking: true})
                                                }}
                                            >

                                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"1.5em",height:"100px"}} src={require('../../../element/2024feb/stop.png')}/>
                                                <div className={classes.displayBg}>
                                                    <div className={classes.displayTitleWrapper}>
                                                        <p className={classes.displayTitle}>TURN TAKING JAM</p>
                                                        <p className={classes.displaySubTitle}>One person at a time!</p>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                justify="center"
                                                alignItems="center"
                                                spacing={0}
                                                className={classes.displayBox}
                                                onClick={()=>{
                                                    this.openFeaturedTemplate(this.featuredIds.brainstorm, {brainstorm: true})
                                                }}
                                            >
                                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"2em",height:"80px"}} src={require('../../../element/2024aug/intellectual.png')}/>
                                                <div className={classes.displayBg}>
                                                    <div className={classes.displayTitleWrapper}>
                                                        <p className={classes.displayTitle}>BRAINSTORM JAM</p>
                                                        <p className={classes.displaySubTitle}>Quick and process oriented</p>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                justify="center"
                                                alignItems="center"
                                                spacing={0}
                                                className={classes.displayBox}
                                                onClick={()=>{
                                                    this.openFeaturedTemplate(this.featuredIds.cover, {cover: true})
                                                }}
                                            >
                                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"3.5em",height:"80px"}} src={require('../../../element/2024aug/painting_board.png')}/>
                                                <div className={classes.displayBg}>
                                                    <div className={classes.displayTitleWrapper}>
                                                        <p className={classes.displayTitle}>COVER JAM</p>
                                                        <p className={classes.displaySubTitle}>Don't judge a book by its cover</p>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/* GET STARTED BUTTONS */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            Create your own
                                        </Grid>
                                    </Grid>
                                </Card>

                                <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"10px"}}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                onClick={()=>{
                                                        this.props.history.push({
                                                            pathname: "/deckbuilder"
                                                        })
                                                }}
                                                justify="center" alignItems="center"
                                                spacing={0}
                                                className={classes.jamBox}
                                            >
                                                <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                    <img style={{marginTop:"5px",width:"80%"}} src={require("../../../element/2024feb/deck_card.png")}/>  
                                                </Grid>
                                                <Grid item xs={8} className={classes.jamBoxFont} style={{color:"#000000"}}>
                                                    <span style={{fontWeight:"900", fontSize:"20px"}}>
                                                        DECK
                                                    </span><br/>
                                                    Create a set promtps in<br/>deck of cards
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                onClick={()=>{
                                                    this.setState({
                                                        selectedJB:{
                                                            type: "basic"
                                                        }
                                                    }, ()=>{

                                                        if(!getUserId()){
                                                            this.props.history.push({
                                                                pathname: "/login",
                                                                state:{
                                                                    selectedJB: this.state.selectedJB,
                                                                    type: "0",
                                                                    jbIndex: this.jbIndex
                                                                }
                                                            })
                                                        }
                                                        else{
                                                            this.handleDisplayInfoClick(this.state.selectedJB)
                                                        }
                                                    });
                                                }}


                                                justify="center" alignItems="center"
                                                spacing={0}
                                                className={classes.jamBox}
                                            >
                                                <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                    <img style={{marginTop:"10px",width:"80%"}} src={require("../../../element/2024feb/auto_template.png")}/>
                                                </Grid>
                                                <Grid item xs={8} className={classes.jamBoxFont} style={{color:"#000000"}}>
                                                    <span style={{fontWeight:"900", fontSize:"20px"}}>
                                                        TEMPLATE <span style={{color:"#C93305",fontSize:"20px"}}>{"(advanced)"}</span>
                                                    </span><br/>
                                                    Add automation and<br/>assemble cards on canvas
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid
                                                container
                                                onClick={()=>{
                                                    window.location.href = `/event/settings`;   
                                                }}
                                                justify="center" alignItems="center"
                                                spacing={0}
                                                className={classes.jamBox}
                                            >
                                                <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                    <img style={{marginTop:"10px",width:"80%"}} src={require("../../../element/2026/calender.png")}/>
                                                </Grid>
                                                <Grid item xs={8} className={classes.jamBoxFont} style={{color:"#000000"}}>
                                                    <span style={{fontWeight:"900", fontSize:"20px"}}>
                                                        EVENT
                                                    </span><br/>
                                                    Create an event with set<br/>of activities
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/* On-going jams */ }

                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            Open Access Jams
                                        </Grid>
                                    </Grid>
                                </Card>

                                <Card className={classes.card}>
                                    <CardContent className={classes.cardContent} style={{marginLeft:"0.75rem"}}>
                                        Spectators allowed to join 👋
                                    </CardContent>
                                    <Divider/>
                                    <CardContent className={classes.cardContent} style={{paddingBottom:"0.5rem"}}>
                                        {/* JAM TITLES */}
                                        <Grid container spacing={2}>
                                        {spectateGame && spectateGame.length !==0 ?
                                            spectateGame.map( (game,index) => (
                                                index < this.state.jamListLength ?

                                                    <Grid key={index} item xs={4}>
                                                        <Grid
                                                            container
                                                            onClick={()=>{window.location.href=`/game/${game._id}`}}
                                                            justify="center"
                                                            alignItems="center"
                                                            spacing={0}
                                                            className={classes.jamBox}
                                                            style={{height:"100px"}}
                                                        >
                                                            {/* JAM IMAGE */}
                                                            <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#BB5E0B"}}>

                                                                <SportsEsportsOutlined style={{color:"white", marginTop:"10px",fontSize:"50px"}}/>
                                                            </Grid>
                                                            {/* JAM INFO */}
                                                            <Grid item xs={8} className={classes.jamBoxFont} style={{padding:"10px", fontSize:"12px"}}>
                                                                <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                                                    {game?.name}
                                                                    {game?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                                                                </span><br/>
                                                                Hosted by {game?.createdBy?.name?.first} <br/>
                                                                <span style={{fontSize:"8px"}}>
                                                                    <PeopleAlt className={classes.jamBoxIcon}/>
                                                                </span>
                                                                {game?.participants?.length } / {game?.data?.general?.playerMode === "Quick" ? 6 : 12}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                :
                                                null
                                                ))
                                            :
                                            <>
                                                <PetsOutlined style={{color:"#C4C4C4", fontSize:"10rem", margin:"auto"}}/>
                                                <p className={classes.jamEmpty}>No one is hosting a jam at this current moment.<br/>
                                                Would you like to host one?</p>
                                            </>
                                            }

                                        </Grid>
                                    </CardContent>
                                    {spectateGame.length>this.state.jamListLength && spectateGame.length !== 0 ?
                                    <>
                                        <Divider/>
                                        <Button className={classes.moreBtn} onClick={this.addJamListLength} style={{padding:"20px 0"}} startIcon={<ExpandMore/>}>
                                            Show {spectateGame.length - this.state.jamListLength >= 12 ? 12 : spectateGame.length - this.state.jamListLength} more
                                        </Button>
                                    </>
                                    : null}
                                </Card>

                                {/* LIST OF GAME JAM TITLES */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                           Privately Hosted Jams
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/* LIST OF JAM TITLE CONTAINER */}
                                <Card className={classes.card}>
                                    <CardContent className={classes.cardContent} style={{marginLeft:"0.75rem"}}>
                                        Invite only allowed to join 🎟
                                    </CardContent>
                                    <Divider/>
                                    <CardContent className={classes.cardContent} style={{paddingBottom:"0.5rem"}}>
                                        {/* JAM TITLES */}
                                        <Grid container spacing={2}>
                                        {gamejams && gamejams.length !==0 ?
                                            gamejams.map( (game,index) => (
                                                index < this.state.jamListLength ?

                                                    <Grid key={index} item xs={4}>
                                                        <Grid
                                                            container
                                                            onClick={()=>{window.location.href=`/game/${game._id}`}}
                                                            justify="center"
                                                            alignItems="center"
                                                            spacing={0}
                                                            className={classes.jamBox}
                                                            style={{height:"100px"}}
                                                        >
                                                            {/* JAM IMAGE */}
                                                            <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#BB5E0B"}}>

                                                                <SportsEsportsOutlined style={{color:"white", marginTop:"10px",fontSize:"50px"}}/>
                                                            </Grid>
                                                            {/* JAM INFO */}
                                                            <Grid item xs={8} className={classes.jamBoxFont} style={{padding:"10px", fontSize:"12px"}}>
                                                                <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                                                    {game?.name}
                                                                    {game?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                                                                </span><br/>
                                                                Hosted by {game?.createdBy?.name?.first} <br/>
                                                                <span style={{fontSize:"8px"}}>
                                                                    <PeopleAlt className={classes.jamBoxIcon}/>
                                                                </span>
                                                                {game?.participants?.length } / {game?.data?.general?.playerMode === "Quick" ? 6 : 12}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                :
                                                null
                                                ))
                                            :
                                            <>
                                                <PetsOutlined style={{color:"#C4C4C4", fontSize:"10rem", margin:"auto"}}/>
                                                <p className={classes.jamEmpty}>No one is hosting a jam at this current moment.<br/>
                                                Would you like to host one?</p>
                                            </>
                                            }

                                        </Grid>
                                    </CardContent>
                                    {gamejams.length>this.state.jamListLength && gamejams.length !== 0 ?
                                    <>
                                        <Divider/>
                                        <Button className={classes.moreBtn} onClick={this.addJamListLength} style={{padding:"20px 0"}} startIcon={<ExpandMore/>}>
                                            Show {gamejams.length - this.state.jamListLength >= 12 ? 12 : gamejams.length - this.state.jamListLength} more
                                        </Button>
                                    </>
                                    : null}
                                </Card>

                                {/* TEMPLATE TITLE */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            Templates by Community
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/*LIST OF TEMPLATE CONTAINER */}
                                <Card className={classes.card}>
                                    <CardContent className={classes.cardContent} style={{marginLeft:"0.75rem"}}>
                                        Discover published jam templates made by the builder community
                                    </CardContent>
                                    <Divider/>
                                    <CardContent className={classes.cardContent} style={{paddingBottom:"0.5rem"}}>
                                        {/* TEMPLATE TITLES */}
                                        <Grid container spacing={2}>
                                        {publicJambuilders && publicJambuilders.length !==0 ?
                                            publicJambuilders.map((jambuilder,index) => (
                                                index < this.state.templateListLength ?
                                                    <Grid key={index} item xs={4}>

                                                    { /*console.log(publicJambuilders)*/}
                                                        <Grid
                                                            container
                                                            onClick={()=>{
                                                                this.setState({
                                                                    dialogOpen: true,
                                                                    selectedJB: {
                                                                        jbData: jambuilder,
                                                                        type: "custom-other"
                                                                    }
                                                                }, () =>{
                                                                    this.jbIndex = index
                                                                });
                                                            }}
                                                            justify="center" alignItems="center"
                                                            spacing={0}
                                                            className={classes.jamBox}
                                                            style={{height:"100px"}}
                                                        >
                                                            <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                                <p style={{marginTop:"7px", fontSize:"36px", fontWeight:"bold"}}>
                                                                    <TableChartOutlined  style={{fontSize:"3rem"}}/>
                                                                </p>
                                                            </Grid>
                                                            <Grid item xs={8} className={classes.jamBoxFont}  style={{padding:"10px", fontSize:"12px"}}>
                                                                <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                                                    {jambuilder?.name}
                                                                    {jambuilder?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                                                                </span><br/>
                                                                Created by {jambuilder?.createdBy?.name?.first} <br/>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                :
                                                null
                                                ))
                                            :
                                            <>
                                                <PetsOutlined style={{color:"#C4C4C4", fontSize:"10rem", margin:"auto"}}/>
                                                <p className={classes.jamEmpty}>No one has built a template yet.<br/>
                                                Want to be the first to build one?</p>
                                            </>
                                            }
                                        </Grid>
                                    </CardContent>
                                    {publicJambuilders.length>this.state.templateListLength && publicJambuilders.length > 0 ?
                                    <>
                                        <Divider/>
                                        <Button className={classes.moreBtn} onClick={this.addTemplateListLength} style={{padding:"20px 0"}} startIcon={<ExpandMore/>}>
                                            Show {publicJambuilders.length - this.state.templateListLength >= 12 ? 12 : publicJambuilders.length - this.state.templateListLength} more
                                        </Button>
                                    </>
                                    : null}
                                </Card>

                                {/* EVENT */}
                                <Card className={`${classes.card} ${classes.cardHeaderContainer}`}>
                                    <Grid container >
                                        <Grid item xs={12} className={classes.cardHeader}>
                                            List of Events
                                        </Grid>
                                    </Grid>
                                </Card>

                                {/*LIST OF EVENT */}
                                <Card className={classes.card}>
                                    <CardContent className={classes.cardContent} style={{marginLeft:"0.75rem"}}>
                                        List of available events
                                    </CardContent>
                                    <Divider/>
                                    <CardContent className={classes.cardContent} style={{paddingBottom:"0.5rem"}}>
                                        {/* EVENT TITLES */}
                                        <Grid container spacing={2}>
                                        {eventList && eventList.length !==0 ?
                                            eventList.map((event,index) => (
                                                index < this.state.templateListLength ?
                                                    <Grid key={index} item xs={4}>

                                                        <Grid
                                                            container
                                                            onClick={()=>{
                                                                console.log(event._id)
                                                                window.location.href = `/event/page/${event._id}`;
                                                            }}
                                                            justify="center" alignItems="center"
                                                            spacing={0}
                                                            className={classes.jamBox}
                                                            style={{height:"100px"}}
                                                        >
                                                            <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                                <p style={{marginTop:"7px", fontSize:"36px", fontWeight:"bold"}}>
                                                                    <TableChartOutlined  style={{fontSize:"3rem"}}/>
                                                                </p>
                                                            </Grid>
                                                            <Grid item xs={8} className={classes.jamBoxFont}  style={{padding:"10px", fontSize:"12px"}}>
                                                                <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                                                    {event?.name}
                                                                </span><br/>
                                                                Created by {event?.createdBy?.name?.first} <br/>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                :
                                                null
                                                ))
                                            :
                                            <>
                                                <PetsOutlined style={{color:"#C4C4C4", fontSize:"10rem", margin:"auto"}}/>
                                                <p className={classes.jamEmpty}>No one has built a template yet.<br/>
                                                Want to be the first to build one?</p>
                                            </>
                                            }
                                        </Grid>
                                    </CardContent>
                                    {publicJambuilders.length>this.state.templateListLength && publicJambuilders.length > 0 ?
                                    <>
                                        <Divider/>
                                        <Button className={classes.moreBtn} onClick={this.addTemplateListLength} style={{padding:"20px 0"}} startIcon={<ExpandMore/>}>
                                            Show {publicJambuilders.length - this.state.templateListLength >= 12 ? 12 : publicJambuilders.length - this.state.templateListLength} more
                                        </Button>
                                    </>
                                    : null}
                                </Card>

                            </Grid>

                            {/* RIGHT COLUMN */}
                            <Grid item sm={3} xs={12}>
                                {/* USER'S RECENT ACTIVITY */}
                                {/* //TODO: Change the user model to accomodate to recent activities */}
                                {uid && activityList &&
                                    <Grid item xs={12}>
                                        <Card className={classes.card} style={{background:"white", marginTop:"0"}}>
                                            <CardContent style={{padding:"20px"}}>
                                                <p style={{fontSize:"20px", fontWeight:"bold"}}>
                                                    Your Recent Activities
                                                </p>
                                                <Grid container>
                                                {
                                                    activityList.length > 0 ?
                                                        this.displayActivity(classes, activityList)
                                                    :
                                                    <>
                                                        <img alt="empty" style={{width:"150px", height:"150px",  marginLeft:"18%"}} src={require('../../../element/cat.png')}/>
                                                        <p className={classes.ownJamEmpty}>
                                                            You don’t have anything on your <br/>dashboard yet. <br/><br/>
                                                            Why don't you start building<br/> or hosting a jam?
                                                        </p>
                                                    </>
                                                }
                                                </Grid>
                                            </CardContent>
                                            {/* {jambuilders.length > this.state.jamBuilderListLength?
                                                this.state.jamBuilderListLength !== jambuilders.length ?
                                                <>
                                                    <Divider/>
                                                    <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength:jambuilders.length})}} startIcon={<ExpandMore/>}>
                                                        Show all
                                                    </Button>
                                                </>
                                                :
                                                <>
                                                    <Divider/>
                                                    <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength: 2})}} startIcon={<ExpandLess/>}>
                                                        Show less
                                                    </Button>
                                                </>
                                            :
                                                 null
                                            }   */}
                                        </Card>
                                    </Grid>
                                }

                                {/* USER'S OWN TEMPLATES */}
                                {uid && jambuilders &&
                                    <Grid item xs={12}>
                                        <Card className={classes.card} style={{background:"white", marginTop:"0"}}>
                                            <CardContent style={{padding:"20px"}}>
                                                <p style={{fontSize:"20px", fontWeight:"bold"}}>
                                                    Your Jam Templates
                                                </p>
                                                <Grid container>
                                                    {
                                                        jambuilders.length > 0 ?
                                                            jambuilders.map( (jambuilder,index) => (
                                                                index < this.state.jamBuilderListLength ?
                                                                <Grid
                                                                    key={`${index + jambuilder}`}
                                                                    container
                                                                    onClick={()=>{
                                                                        this.setState({
                                                                            dialogOpen: jambuilder.status!=="interpreted" ? false : true,
                                                                            selectedJB: {
                                                                                jbData: jambuilder,
                                                                                type: "custom-personal"
                                                                            }
                                                                        }, () =>{
                                                                            if(jambuilder.status!=="interpreted"){
                                                                                this.handleDisplayInfoClick(this.state.selectedJB)
                                                                            }
                                                                            else{
                                                                                this.jbIndex = index
                                                                                this.jbID = this.state.selectedJB.jbData._id
                                                                            }
                                                                        });
                                                                    }}
                                                                    justify="center"
                                                                    alignItems="center"
                                                                    spacing={0}
                                                                    className={classes.jamBox}
                                                                    style={{height:"100px"}}
                                                                >
                                                                    <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                                                                        <p className={classes.ownJamIcon}>
                                                                            <TableChartOutlined  style={{fontSize:"3rem"}}/>
                                                                        </p>
                                                                    </Grid>
                                                                    <Grid item xs={8} className={classes.jamBoxFont}  style={{fontSize:"12px", padding:"10px"}}>
                                                                        <Button
                                                                            style={{position:"absolute", top:"-15px", left:"5px", outline:"none", background:"white", color:"#828282", height:"20px", fontSize:"2px", }}
                                                                            disabled startIcon={<TableChartOutlined style={{color:"#828282", fontSize:"14px"}}/>}>
                                                                            <span style={{fontSize:"10px"}}>TEMPLATE</span>
                                                                        </Button>
                                                                        <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                                                            {jambuilder.name}
                                                                        </span><br/>
                                                                        Created by <span style={{color:"#4173D6"}}>{getUsername()}</span><br/>

                                                                        <div style={{position:"absolute", bottom:"-15px", right:"5px"}}>
                                                                        {/*  ONCE PUBLISHED IS ESTABLISHED */}
                                                                        {/* <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOffOutlined/>}>PRIVATE</Button>
                                                                        <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOutlined/>}>PUBLIC</Button>
                                                                        <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled> PUBLISHED</Button> */}
                                                                        {jambuilder.status === "interpreted"
                                                                            ?
                                                                                jambuilder.general.privacy === "Public" ?
                                                                                <>
                                                                                    <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                                                                                    startIcon={<VisibilityOutlined style={{fontSize:"14px"}}/>}>
                                                                                        <span style={{fontSize:"10px"}}>
                                                                                            PUBLIC
                                                                                        </span>
                                                                                    </Button>
                                                                                    <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                                                                                        <span style={{fontSize:"10px"}}>
                                                                                            PUBLISHED
                                                                                        </span>
                                                                                    </Button>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                                                                                    startIcon={<VisibilityOffOutlined style={{fontSize:"14px"}}/>}>
                                                                                        <span style={{fontSize:"10px"}}>
                                                                                            PRIVATE
                                                                                        </span>
                                                                                    </Button>
                                                                                    <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                                                                                        <span style={{fontSize:"10px"}}>
                                                                                            PUBLISHED
                                                                                        </span>
                                                                                    </Button>
                                                                                </>

                                                                            :
                                                                            <Button style={{color:"white", background:"#c4c4c4"}} disabled classes={{disabled: classes.ownJamLabel}} >
                                                                                <span style={{fontSize:"10px"}}>
                                                                                    UNPUBLISHED
                                                                                </span>
                                                                            </Button>
                                                                        }
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                                :
                                                                null
                                                            ))
                                                        :

                                                        <>
                                                            <img alt="empty" style={{width:"150px", height:"150px", marginLeft:"18%"}} src={require('../../../element/cat.png')}/>
                                                            <p className={classes.ownJamEmpty}>
                                                                You don’t have anything on your <br/>dashboard yet. <br/><br/>
                                                                Why don't you start building<br/> or hosting a jam?
                                                            </p>
                                                        </>
                                                    }

                                                </Grid>
                                            </CardContent>
                                            {jambuilders.length > this.state.jamBuilderListLength?
                                                this.state.jamBuilderListLength !== jambuilders.length ?
                                                <>
                                                    <Divider/>
                                                    <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength:jambuilders.length})}} startIcon={<ExpandMore/>}>
                                                        Show all
                                                    </Button>
                                                </>
                                                :
                                                <>
                                                    <Divider/>
                                                    <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength: 2})}} startIcon={<ExpandLess/>}>
                                                        Show less
                                                    </Button>
                                                </>
                                            :
                                                 null
                                            }
                                        </Card>
                                    </Grid>
                                }

                                {/* BANNER */}
                                {!uid &&
                                    <Grid item xs={12}>
                                        <img alt="banner" className={classes.banner} src={require('../../../element/banner6.png')}/>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        {/* FOOTER */}

                        <FooterPanel/>

                        {/* POP UP */}
                        <Modal disableAutoFocus={true} className={classes.modal} open={this.state.open} onClose={this.handleClose}>
                            {this.popUp(classes)}
                        </Modal>

                        {/* HELP POPOVER */}
                        <ClickAwayListener onClickAway={this.closePopper}>
                            <div>
                                <HelpPopover
                                    id={popoverId}
                                    anchorEl={this.state.anchorEl}
                                />
                                <HelpFab openHelpPopper={this.openPopper} />
                            </div>
                        </ClickAwayListener>

                        {/* TEMPLATE PREVIEW DIALOG */}
                        <Dialog
                            onClose={() =>
                                this.setState({
                                    dialogOpen: false,
                                    dialogDeck: null,
                                })}
                            open={this.state.dialogOpen}
                        >
                            {this.state.dialogOpen && this.displayInfo()}
                        </Dialog>
                    </>
                }
            </>
        )
    }

    handleDropFile = (files) => {
        // console.log('Drop file', files);
        const file = files.shift();
        this.setState({
            templateImage: {...files}
        })
        //console.log(this.state.draft.toObject());
        // this.state.draft.syncImage(file);

        const data = new FormData();
        data.append('image', file);

        // const req = request.post(`${config.backend.uri}/upload`);
        const req = request.post(`${config.backend.uri}/api/upload`);

        req.on('progress', (event) => {
          const percent = Math.floor(event.percent);
          if (percent >= 100) {
            this.setState({ imageCompleted: 100 });
          } else {
            this.setState({ imageCompleted: percent });
          }
        });
        req.send(data);
        req.end((err, res) => {
          // this.state.draft.set('image', { ...file, ...res.body.data.upload });
          this.setState({
              templateImage: {...file, ...res.body.data.upload}
          })

          // console.log(this.state.templateImage)
        });
    }

    //Help popper
    openPopper = (e) =>{
        this.setState({
            anchorEl: e.currentTarget
        });
    }

    //Help popper
    closePopper = () =>{
        this.setState({
            anchorEl: null
        });
    }

    jamPageQuery = (uid) =>{
        this.props.client.query({
            query: gql`${HOME_PAGE_JAMBUILDER_QUERY}`,
            variables: {uid: uid}
        })
        .then((res) =>{
            const {jamBuilderMany, eventMany} = res.data
            let personalJamBuilders = []
            let publicJambuilders = []

            this.props.client.query({
                query: GET_USER_ACTIVITY(uid)
            }).then((res) =>{
                //recentActivity has recentTemplates and recentJams,
                //these two data will store the oldest accessed activities starting from 0

                const recentActivity = res.data.userById.recentActivity
                const recentTemplates = recentActivity.recentTemplates.map((template) =>{
                    return template._id
                })
                const recentJams = recentActivity.recentJams.map((game) =>{
                    return game._id
                })

                //Perhaps there's a better way to query activity, perhaps not
                //I spent way too much time and care so this nested query is the only way for now
                this.props.client.query({
                    query: gql`${GET_JAMS_TEMPLATES}`,
                    variables:{tempList : recentTemplates, jamList: recentJams}
                }).then((res) =>{

                    //Combines both objects into one based on ID
                    const jamBuilders = res.data.jamBuilderFilter.map(obj => Object.assign(obj, recentActivity.recentTemplates.find(templates => obj._id === templates._id)))
                    const games = res.data.gameFilter.map(obj => Object.assign(obj, recentActivity.recentJams.find(templates => obj._id === templates._id)))
                    
                    let activityList = jamBuilders.concat(games)

                    let sortedActivity = activityList.sort((a, b) => (new Date(a.date).getTime()) < (new Date(b.date).getTime()) ? 1 : (( (new Date(b.date).getTime()) <  (new Date(a.date).getTime())) ? -1 : 0))

                    jamBuilderMany.forEach((jamBuilder) => {
                        if(jamBuilder.createdBy._id === uid){
                            personalJamBuilders.push(jamBuilder)
                        }

                        if(jamBuilder?.general?.privacy === "Public" && jamBuilder?.status === "interpreted"){
                            publicJambuilders.push(jamBuilder)
                        }
                    })

                    this.setState({
                        jambuilders: personalJamBuilders.reverse(),
                        publicJambuilders: publicJambuilders.reverse(),
                        uid: uid,
                        activityList: sortedActivity,
                        eventList: eventMany
                    }, ()=>{
                        if(this.props?.location?.state?.openPreview){
                            this.reloadPage()

                            const {jbID} = this.props.location.state
                            let jbData = null

                            for(let i=0; i<this.state.jambuilders.length; i++){
                                if (this.state.jambuilders[i]._id === jbID){
                                    jbData = this.state.jambuilders[i]
                                    this.jbIndex = i
                                    break
                                }
                            }
                            this.jbID = jbID

                            this.setState({
                                dialogOpen: true,
                                selectedJB: {
                                    jbData: jbData,
                                    type: "custom-personal"
                                }
                            })
                        }
                    })
                })
            })
        })
        .catch(() =>{
            return <div>Error :( : frontpage </div>
        })
    }

    reloadPage = () =>{
        // The last "domLoading" Time //
        var currentDocumentTimestamp =
        new Date(performance.timing.domLoading).getTime();
        // Current Time //
        var now = Date.now();
        // Ten Seconds //
        var tenSec = 10 * 1000;
        // Plus Ten Seconds //
        var plusTenSec = currentDocumentTimestamp + tenSec;
        if (now > plusTenSec) {
            window.location.reload();
        } else {

        }
    }
    getParameter = () =>{
        return window.location.href.slice(-1)
    }

    addJamListLength = () => {
        this.setState({
            jamListLength: this.state.jamListLength + 12
        })
    }

    addTemplateListLength = () => {
        this.setState({
            templateListLength: this.state.templateListLength + 12
        })
    }

    handleOpen(getType){
        this.setState({
            open: true,
            type: getType
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    passwordChecker = () => {
        if(this.state.password === ""){
            return null
        }else{
            return this.state.password
        }
    }

    handleChange = (event) => {
        let item = event.target.name
        this.setState({
            [item]: event.target.value
        })
    }

    handleCreateJam = () => {
        if (this.state.loading) {
            return;
        }

        if (this.state.type === '' || this.state.name === ''){
            alert('Please Fill All Information!');

            return;
        }

        this.createGame();
        this.setState({ loading: true });
    };

    //Game/Jambuilder modal
    popUp = (classes) => {
        //Note: type === 1 is Jam, 0 is Template
        const {type} = this.state

        return (
            <Card className={classes.popUp}>
                <div className={classes.popUpHeader}>
                    {type !== "0" ? "Host a new Jam" : "Create a new Template"}
                </div>
                <Divider/>
                <div className={classes.popUpContent}>
                    <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                        <b>{type !=="0" ? "Jam Name *" : "Template Name *"}</b>
                        <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                        <InputBase
                            className={classes.field}
                            placeholder="Example: Wayne's World"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleChange}
                            inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                        />
                        {type !== "0" ?
                        <>
                            <div style={{fontSize:"0.875rem", color:"#4F4F4F",}}>
                                <b>Jam Password</b>
                                <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                                <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Only those with your jam’s password may view your waiting room. If none is set, anyone can view your waiting room!</p>
                            </div>
                            <InputBase
                                className={classes.field}
                                type="password"
                                placeholder="password"
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                            />
                        </> :
                        null
                        }
                        {type !== "0" ?
                        <>
                            <Button
                                onClick={this.handleCreateJam}
                                disabled={(this.state.name === '' ? true : false) || this.state.loading}
                                className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                            >
                                Go to waiting room
                            </Button>
                        </> :
                        <>
                            <Button
                                onClick={()=>{
                                    if(this.state.name === ""){
                                        alert("Please Fill All Information!")
                                    }else{
                                        this.createTemplate()
                                    }
                                }}
                                disabled={this.state.name === "" ? true:false}
                                className={this.state.name === "" ? classes.popUpBtnDisabled : classes.popUpBtn}
                            >
                                Go to Template Builder
                            </Button>
                        </>
                        }
                    </FormControl >
                </div>
            </Card>
        )
    }

    //Dialog popup to display info
    displayInfo = () =>{
        const {classes} = this.props
        const {selectedJB} = this.state
        //Default dialog data starts with "Basic Game"
        let image = require('../../../element/default-image.png')
        let name = "Basic Game"
        let description = "The most basic template ready to be used and modified to your needs. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
        let endpoint = "storyDesign"

        // if redirect set jbID to redirect jbID
        if(this.props.location?.state?.redirect){
            this.jbID = this.props.location.state.jbID
        }

        if(selectedJB.type === "custom-personal" || selectedJB.type === "custom-other"){
            selectedJB?.jbData?.image ?
                image = `${config.backend.uri}/static/uploads/${selectedJB.jbData.image}` :
                image = require('../../../element/default-image.png')

            name = selectedJB.jbData.name
            description = selectedJB?.jbData?.general?.description
            endpoint = selectedJB.jbData.deckEndpoint
        }
        else if(selectedJB.type === "story"){
            name = "Story Game"
            description = "Everything you need to have to build story game. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
            image = require('../../../element/OUAT1.jpg')
        }
        else if(selectedJB.type === "freeStyle"){
            name = "Free Style"
            description = "A jam in its simplest form. This template consists of many sets of card decks from Topics to Characters while allowing everyone to jam together at the same time."
        }

        if(!this.state.dialogDeck){

            // storyDesign is a shared deck file that always exists, so read it directly.
            // Any other (custom) deck is sourced from the JamBuilder record instead of
            // getCustomDeck: the record stores the deck dump, so this works for templates
            // copied from another user — the old per-user file read 500'd because the deck
            // file only exists under the ORIGINAL owner's dir, not the copying user's.
            // dialogDeck falls back to [] (truthy) so a missing/empty deck won't refetch-loop.
            if(endpoint === "storyDesign"){
                axios.get(`${config.backend.uri}/api/game/getDeck`,{params: {endpoint}}).then((res)=>{
                    this.setState({ dialogDeck: res.data.deck?.elements || [] })
                }).catch(()=> this.setState({ dialogDeck: [] }))
            }else{
                this.props.client.query({
                    query: GET_JAMBUILDER_BY_ID(selectedJB.jbData._id),
                    fetchPolicy: "no-cache",
                }).then((res)=>{
                    const deck = res.data?.jamBuilderById?.deck
                    this.setState({ dialogDeck: deck?.elements || [] })
                }).catch(()=> this.setState({ dialogDeck: [] }))
            }
        }
        else{
            return(
                <div className={classes.preview}>
                    <Grid container>
                        <Grid item xs={8}>
                            {/* <img alt="media-preview" className={classes.previewImage} src={image}/>   */}

                            <div style={{backgroundImage: `url(${image})`}} className={classes.previewImage}></div>

                            <p style={{fontSize:"14px",fontWeight:"bold", color:"#4F4F4F"}}>
                                {name}
                            </p>
                            <p style={{paddingRight:"20px", color:"#4F4F4F", fontSize:"14px"}}>
                                {description}
                            </p>
                        </Grid>
                        <Grid item xs ={4}>
                            <Button
                                className={classes.previewBtn}
                                onClick={()=>{
                                    if(!getUserId()){
                                        this.props.history.push({
                                            pathname: "/login",
                                            state:{
                                                selectedJB: selectedJB,
                                                type: "1",
                                                jbIndex: this.jbIndex
                                            }
                                        })
                                    }
                                    else{
                                        this.setState({
                                            dialogOpen: false
                                        },()=>{
                                            this.handleOpen("1")
                                        })
                                    }
                                }}
                                size={"small"}

                            >
                                Host This Template
                            </Button>

                            <p style={{textAlign:"center"}}>
                                <Link
                                    style={{
                                        color:"orange",
                                        fontSize:"14px",
                                        fontWeight:"bold",
                                        textDecoration:"underline",
                                        cursor:"pointer",
                                    }}
                                    size={"small"}
                                    onClick={()=>{
                                        if(!getUserId()){
                                            this.props.history.push({
                                                pathname: "/login",
                                                state:{
                                                    selectedJB: selectedJB,
                                                    type: "0",
                                                    jbIndex: this.jbIndex
                                                }
                                            })
                                        }
                                        else{
                                            this.handleDisplayInfoClick(selectedJB)
                                        }
                                    }}
                                >
                                    Customize this Template
                                </Link>
                            </p>
                            <p style={{fontWeight:"bold", marginTop:"20px", fontSize:"14px", color:"#4F4F4F"}}>
                                Deck List ({this.state.dialogDeck?.length})
                            </p>

                            {this.state.dialogDeck.slice(0,3).map((card, index) =>{
                                return(
                                    <div key={`${card}-${index}`} className={classes.previewCard}>
                                        <p style={{fontWeight:"bold", color:"#4F4F4F"}}>
                                           {card.content}
                                        </p>
                                        <Tooltip title="Category">
                                            <p style={{background:"#5C969A",}} className={classes.previewCardLabel}>
                                                <Apps className={classes.previewCardIcon}/>
                                                {card.category}
                                            </p>
                                        </Tooltip>
                                        {card.label.map((label, index) =>{
                                            return (
                                                <Tooltip key={`${label}-${index}`} title="Label">
                                                    <p style={{background:"#967B7B"}} className={classes.previewCardLabel}>
                                                        <LocalOfferOutlined className={classes.previewCardIcon}/>
                                                        {label}
                                                    </p>
                                                </Tooltip>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </Grid>
                    </Grid>
                </div>
            )
        }
    }

    displayActivity = (classes, activityList) =>{
        let listArr = []

        for(let index = 0; index < activityList.length; index++){
            let activity = activityList[index]
            if(index > 2){
                break
            }
            else if(activity.__typename === "UserRecentActivityRecentTemplates"){
                listArr.push(
                    <Grid
                        key={`${index + activity}`}
                        container
                        justify="center"
                        alignItems="center"
                        spacing={0}
                        className={classes.jamBox}
                        style={{height:"100px"}}
                        onClick={()=>{
                            this.setState({
                                dialogOpen: activity.status!=="interpreted" ? false : true,
                                selectedJB: {
                                    jbData: activity,
                                    type: "custom-personal"
                                }
                            }, () =>{
                                if(activity.status!=="interpreted"){
                                    this.handleDisplayInfoClick(this.state.selectedJB)
                                }
                                else{
                                    this.jbIndex = index
                                    this.jbID = this.state.selectedJB.jbData._id
                                }
                            });
                        }}
                    >
                        <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                            <p className={classes.ownJamIcon}>
                                <TableChartOutlined  style={{fontSize:"3rem"}}/>
                            </p>
                        </Grid>
                        <Grid item xs={8} className={classes.jamBoxFont} style={{fontSize:"12px",padding:"10px"}}>
                            <Button style={{position:"absolute", top:"-15px", left:"5px", outline:"none", background:"white", color:"#828282", height:"20px", fontSize:"2px", }} disabled
                                startIcon={<TableChartOutlined style={{color:"#828282", fontSize:"14px"}}/>}>
                                <span style={{fontSize:"10px"}}>TEMPLATE</span>
                            </Button>
                            <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                {activity.name}
                            </span><br/>
                            Created by <span style={{color:"#4173D6"}}>{activity.createdBy.name.first}</span><br/>
                                                    <div style={{position:"absolute", bottom:"-15px", right:"5px"}}>
                            {/*  ONCE PUBLISHED IS ESTABLISHED */}
                            {/* <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOffOutlined/>}>PRIVATE</Button>
                            <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOutlined/>}>PUBLIC</Button>
                            <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled> PUBLISHED</Button> */}
                            {activity.status === "interpreted"
                                ?
                                activity.general.privacy === "Public" ?
                                <>
                                    <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                                    startIcon={<VisibilityOutlined style={{fontSize:"14px"}}/>}>
                                        <span style={{fontSize:"10px"}}>
                                            PUBLIC
                                        </span>
                                    </Button>
                                    <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                                        <span style={{fontSize:"10px"}}>
                                            PUBLISHED
                                        </span>
                                    </Button>
                                </>
                                :
                                <>
                                    <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                                    startIcon={<VisibilityOffOutlined style={{fontSize:"14px"}}/>}>
                                        <span style={{fontSize:"10px"}}>
                                            PRIVATE
                                        </span>
                                    </Button>
                                    <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                                        <span style={{fontSize:"10px"}}>
                                            PUBLISHED
                                        </span>
                                    </Button>
                                </>
                                :
                                <Button style={{color:"white", background:"#c4c4c4"}} disabled classes={{disabled: classes.ownJamLabel}} >
                                     <span style={{fontSize:"10px"}}>
                                        UNPUBLISHED
                                    </span>
                                </Button>
                            }
                            </div>
                        </Grid>
                    </Grid>
                )
            }
            else if(activity.__typename === "UserRecentActivityRecentJams"){
                listArr.push(
                    <Grid
                        key={`${index + activity}`}
                        container
                        justify="center"
                        alignItems="center"
                        spacing={0}
                        className={classes.jamBox}
                        style={{height:"100px"}}
                        onClick={() =>{
                            this.props.client.mutate({
                                mutation: USER_UPDATE_ACTIVITY,
                                variables:{
                                    _id: this.state.uid,
                                    _aid: activity._id,
                                    type: "jam",
                                    date: new Date()
                                }
                            }).then(() =>{
                                this.props.history.push({
                                    pathname: `/game/${activity._id}`
                                })
                            })
                        }}
                    >
                        {/* JAM IMAGE */}
                        <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#BB5E0B"}}>
                            <SportsEsportsOutlined style={{color:"white", marginTop:"15px",fontSize:"50px"}}/>
                        </Grid>
                        {/* JAM INFO */}
                        <Grid item xs={8} className={classes.jamBoxFont} style={{fontSize:"12px", padding:"10px"}}>
                            <Button style={{position:"absolute", top:"-5px", left:"5px", outline:"none", background:"white", color:"#828282", height:"20px"}} disabled
                            startIcon={<SportsEsportsOutlined style={{color:"#828282", fontSize:"14px"}}/>}>
                            <span style={{fontSize:"10px"}}>JAMSPACE</span>
                            </Button>
                            <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                {activity?.name}
                                {activity?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                            </span><br/>
                            Hosted by {activity?.createdBy?.name?.first} <br/>
                            <span style={{fontSize:"8px"}}>
                                <PeopleAlt className={classes.jamBoxIcon}/>
                            </span>
                            {activity?.participants?.length } / {activity?.data?.general?.playerMode === "Quick" ? 6 : 12}
                        </Grid>
                    </Grid>
                )
            }
        }

        return listArr
    }

    handleDisplayInfoClick = (selectedJB) =>{
        if(selectedJB.type === "custom-personal"){
            const {uid} = this.state

            this.props.client.mutate({
                mutation: USER_UPDATE_ACTIVITY,
                variables:{
                    _id: uid,
                    _aid: selectedJB.jbData._id,
                    type: "template",
                    date: new Date()
                }
            }).then(() =>{
                window.location.href=`/jambuilder/${selectedJB.jbData._id}`
            })
        }
        else{
            this.setState({
                dialogOpen: false,
            }, () =>{
                this.handleOpen("0")
            });
        }
    }

    createGame = () =>{
        let jamBuilder = null

        if(this.state.selectedJB.type === "custom-personal"){
            jamBuilder = this.state.jambuilders.find((jambuilder) => {
                if(jambuilder._id === this.jbID){
                    return jambuilder
                }
                else{
                    return false
                }
            })
        }
        else if(this.state.selectedJB.type === "custom-other"){
            jamBuilder = this.state.publicJambuilders[this.jbIndex]
        }

        //featured templates (Brainstorm/Cover) are lazy-fetched into selectedJB.jbData
        //(openFeaturedTemplate) and aren't in publicJambuilders, so use jbData directly.
        if(this.state.selectedJB.brainstorm || this.state.selectedJB.cover || this.state.selectedJB.turntaking || this.state.selectedJB.freeplay){
            jamBuilder = this.state.selectedJB.jbData
        }

        const {name} = this.state
        const creator = getUserId();

        if(jamBuilder?.general && "gameLink" in jamBuilder.general){
            // duplicate jam
            // console.log("duplicate jam")
            let setup = {
                createdBy: creator,
                name,
                password: this.passwordChecker(),
            }

            this.props.client.mutate({
                mutation: DUPLICATE_GAME,
                variables: {
                    _id: jamBuilder.general.gameLink,
                    setup,
                }
            }).then((status)=>{
                console.log(status)
                this.setState({name:"",password:"", type: ""});
                this.jbIndex = null
                window.location.href=`/game/${status.data.gameDuplicate._id}`
                //window.location.reload(); // temporary for jambuilder setup
            })
        }else{
            
            const general = jamBuilder?.general ?
                                jamBuilder.general :
                                {
                                    name: "Game Jam",
                                    deckEndpoint: "storyDesign",
                                    rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                    description:"",
                                    privacy:"Private",
                                    playerMode:"Quick",
                                    spectateMode:true,
                                }
            const data = {
                objects : [],
                latestObject : null,
                playerTurn: 0,
                turn: 1,
                phase: [],
                latestID: "0",
                general: general
            }

            this.props.client.mutate({
                mutation: CREATE_GAME,
                variables:{
                    name: name,
                    createdBy: creator,
                    data: data,
                    automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                    "JB:" + jamBuilder.configIndex + "/yamlConfig" :
                                    this.state.selectedJB.type,
                    password: this.passwordChecker(),
                    setup: false,
                    status: this.state.selectedJB.cover ? "started" : "ready"
                }
            }).then((status)=>{
                this.setState({name:"",password:"", type: ""});
                this.jbIndex = null
                window.location.href=`/game/${status.data.gameCreateOne._id}`
                //console.log(status)
            })
        }
    }

    createTemplate = () =>{
        const creator = getUserId();
        const username = getUsername();
        const {jambuilders, selectedJB, publicJambuilders, uid} = this.state

        let jamBuilderGraph = []
        let general = {}
        let jamBuilder = null

        if(selectedJB.type === "custom-personal"){
            jamBuilder = jambuilders.find((jb) => {
                if(jb._id === this.jbID){
                    return jb
                }else{
                    console.log(false)
                }
            })
            jamBuilderGraph = jamBuilder.graph
            general = jamBuilder.general

            // jamBuilderGraph = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.graph
            //     }
            //     else{
            //         return false
            //     }
            // })
            // general = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.general
            //     }
            //     else{
            //         return false
            //     }
            // })
        }
        else if(selectedJB.type === "custom-other"){
            jamBuilder = publicJambuilders[this.jbIndex]
            jamBuilderGraph = publicJambuilders[this.jbIndex].graph
            general = publicJambuilders[this.jbIndex].general
        }

        let deckEndpoint = this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ? 
                                {
                                    endpoint: this.state.selectedJB.jbData.deckEndpoint ,
                                    userDir: `${this.state.selectedJB.jbData.createdBy._id}-${replaceWhiteSpace(this.state.selectedJB.jbData.createdBy.name.first)}`,
                                }
                            : 
                                {
                                    endpoint: "storyDesign",
                                }
                                
        let deckAPI = deckEndpoint.endpoint === "storyDesign" ? `/api/game/getDeck` : `/api/game/getCustomDeck`;
        
        console.log(deckEndpoint)

        axios.get(`${config.backend.uri}${deckAPI}`,{params: deckEndpoint}).then((res)=>{
            let deck = res.data.deck

            const name = "Untitled Jam"
            const creator = getUserId();
            const gameGeneral = 
                                {
                                    name: "Game Jam",
                                    deckEndpoint: "storyDesign",
                                    rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                    description:"",
                                    privacy:"Private",
                                    playerMode:"Quick",
                                    spectateMode: true,
                                }
            const data = {
                objects : [],
                latestObject : null,
                playerTurn: 0,
                turn: 1,
                phase: [],
                latestID: "0",
                general: gameGeneral
            }
    
            this.props.client.mutate({
                mutation: CREATE_GAME,
                variables:{
                    name: name,
                    createdBy: creator,
                    data: data,
                    // automation: "story",
                    automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                "JB:" + jamBuilder.configIndex + "/yamlConfig" : this.state.selectedJB.type,
                    setup: false,
                    build: true,
                }
            }).then((status)=>{
                let jbGeneral = gameGeneral
                jbGeneral.gameLink = status.data.gameCreateOne._id
                let gameID = status.data.gameCreateOne._id

                this.props.client.mutate({
                    mutation: CREATE_JAMBUILDER,
                    variables:{
                        name: this.state.name,
                        createdBy: creator,
                        configIndex: `${creator}-${replaceWhiteSpace(username)}-${jambuilders.length+1}`,
                        deckEndpoint:  this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                            this.state.selectedJB.jbData.deckEndpoint :
                                            "storyDesign",
                        templateType: this.state.selectedJB.type,
                        jamBuilderGraph: jamBuilderGraph,
                        general: jbGeneral,
                        deck: deck,
                    }
                }).then((status) =>{

                    let fgd; // *** TEMPORARY FOR FREESTYLE & STORY
                    if(this.state.selectedJB.type === "story"){
                        fgd = gd
                    }else{
                        fgd = gd2
                    }

                    fgd.builderID = status.data.jamBuilderCreateOne._id
                    // console.log(gameID)
                    this.props.client.mutate({
                        mutation: GAME_GD_UPDATE_BY_ID,
                        variables: {
                          _id : gameID,
                          gameData: fgd
                        }
                    })

                    this.props.client.mutate({
                        mutation: USER_UPDATE_ACTIVITY,
                        variables:{
                            _id: uid,
                            _aid: status.data.jamBuilderCreateOne._id,
                            type: "template",
                            date: new Date()
                        }
                    }).then(() =>{
                        this.props.history.push({
                            pathname: `/jambuilder/${status.data.jamBuilderCreateOne._id}`,
                            state: {type: this.state.selectedJB.type}
                        })
                        this.setState({name: "", selectedJB: {type: null, jbData: null}});
                    })
    
                })  
            })
        })

    }
}


export default withApollo(withRouter(withStyles(styles)(FrontPage)));
